module.exports = __webpack_public_path__ + "img/img-2.e9a6e646.jpg";